import { InjectionToken } from '@angular/core';
import { TASLibConfig } from './tas-lib.config';

export const TAS_LIB_CONFIG = new InjectionToken<TASLibConfig>('TAS_LIB_CONFIG');